import { Alert, Button } from '@mui/material'

interface AdminDataErrorProps {
  message: string
  onRetry: () => void
}

export function AdminDataError({ message, onRetry }: AdminDataErrorProps) {
  return (
    <Alert
      severity="error"
      variant="outlined"
      sx={{ mb: 2.5, bgcolor: '#FFF8F8', borderColor: '#F5C2C5' }}
      action={<Button color="error" variant="text" size="small" onClick={onRetry}>Try again</Button>}
    >
      {message}
    </Alert>
  )
}
